import { render } from "./AdminPage.vue?vue&type=template&id=a741ed96&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"

import "./AdminPage.vue?vue&type=style&index=0&id=a741ed96&scoped=true&lang=css"
import "../css/admin.css?vue&type=style&index=1&id=a741ed96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a741ed96"]])

export default __exports__